import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "./data";
import { MaskedLines, Reveal } from "./Reveal";
import { useSmoothScroll } from "../../App";

export default function Closing() {
  const scrollTo = useSmoothScroll();
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-70, 70]);

  return (
    <section ref={ref} data-testid="closing-section" className="relative overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0 -top-24 -bottom-24">
        <img
          src={IMAGES.fishingNetsSunset}
          alt="Chinese fishing nets silhouetted against the setting sun in Fort Kochi"
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-forest/70" aria-hidden="true" />

      <div className="relative z-10 mx-auto flex min-h-[88svh] max-w-editorial flex-col items-center justify-center px-6 py-32 text-center md:px-10">
        <Reveal>
          <p className="flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.34em] text-saffron">
            <span className="h-px w-10 bg-saffron/70" aria-hidden="true" />
            The last evening
            <span className="h-px w-10 bg-saffron/70" aria-hidden="true" />
          </p>
        </Reveal>
        <MaskedLines
          as="h2"
          delay={0.2}
          className="mt-8 font-serif font-light leading-[1.08] text-ivory text-[clamp(2.3rem,5.6vw,5rem)]"
          lines={["You will leave with full memory cards —"]}
        />
        <MaskedLines
          as="p"
          delay={0.5}
          className="mt-1 font-serif font-light italic leading-[1.08] text-saffron text-[clamp(2.3rem,5.6vw,5rem)]"
          lines={["and a slower pulse."]}
        />
        <Reveal delay={0.65}>
          <button
            data-testid="closing-enquire-button"
            onClick={() => scrollTo("#enquire")}
            className="mt-14 bg-saffron px-9 py-4 text-[11px] font-semibold uppercase tracking-[0.26em] text-forest transition-colors duration-300 hover:bg-ivory"
          >
            Reserve your departure
          </button>
        </Reveal>
      </div>
    </section>
  );
}
